export const LISTER_NO_RESULTS_PATH = 'lister/no-results';
export const LISTER_TILES_ID = 'product-tile-lister';
